
export const RightIcon = () => (
  <svg width="11" height="17" viewBox="0 0 11 17" fill="none" stroke="#191F42" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 1L9 8.5L1.5 16" strokeWidth="2" />
  </svg>
);
